// extracted by mini-css-extract-plugin
export default {"orderItem":"OrderDetail_orderItem__rzX3R","order":"OrderDetail_order__FLIia","products":"OrderDetail_products__E60CP"};